import { colors } from "styles/colors";

type Props = {
  className?: string;
};

export const AnimeCharacterIcon: React.FC<Props> = ({ className = 'w-5 h-5' }) => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="3.99688" cy="3.73345" r="2.66667" fill={colors.gray900} stroke={colors.gray900} strokeWidth="1.06667" />
      <circle cx="20.5301" cy="3.73345" r="2.66667" fill={colors.gray900} stroke={colors.gray900} strokeWidth="1.06667" />
      <path
        d="M2.93099 8C2.93099 5.53887 4.16709 3.68862 5.93 2.43459C7.70568 1.17149 9.99524 0.533329 11.9977 0.533329C14.0001 0.533329 16.2896 1.17148 18.0653 2.43459C19.8282 3.68862 21.0643 5.53887 21.0643 8C21.0643 9.80369 20.7385 11.1479 20.2157 12.1541C19.6955 13.1553 18.9662 13.8496 18.1107 14.3365C16.3715 15.3262 14.103 15.4667 11.9977 15.4667C9.89235 15.4667 7.62385 15.3262 5.88464 14.3365C5.02908 13.8496 4.2998 13.1553 3.77963 12.1541C3.25684 11.1479 2.93099 9.80369 2.93099 8Z"
        fill="white"
        stroke={colors.gray900}
        strokeWidth="1.06667"
      />
      <mask
        id="mask0_11830_10182"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="2"
        y="0"
        width="20"
        height="16"
      >
        <path
          d="M2.93099 8C2.93099 5.53887 4.16709 3.68862 5.93 2.4346C7.70568 1.17149 9.99524 0.533335 11.9977 0.533335C14.0001 0.533334 16.2896 1.17149 18.0653 2.4346C19.8282 3.68862 21.0643 5.53887 21.0643 8C21.0643 9.80369 20.7385 11.1479 20.2157 12.1541C19.6955 13.1553 18.9662 13.8496 18.1107 14.3365C16.3715 15.3262 14.103 15.4667 11.9977 15.4667C9.89235 15.4667 7.62385 15.3262 5.88464 14.3365C5.02908 13.8496 4.2998 13.1553 3.77963 12.1541C3.25684 11.1479 2.93099 9.80369 2.93099 8Z"
          fill="white"
          stroke={colors.gray900}
          strokeWidth="1.06667"
        />
      </mask>
      <g mask="url(#mask0_11830_10182)">
        <path
          d="M21.4971 10.6113C22.185 11.3389 21.4427 13.0103 20.4329 13.8555C19.4231 14.7006 18.0468 14.796 17.3589 14.0684C16.6709 13.3408 16.9319 12.0658 17.9417 11.2207C18.9516 10.3755 20.8092 9.88371 21.4971 10.6113Z"
          fill={colors.pink500}
        />
        <path
          d="M2.54389 10.6113C1.85598 11.3389 2.5983 13.0103 3.60813 13.8555C4.61795 14.7006 5.99424 14.796 6.68216 14.0684C7.37007 13.3408 7.10911 12.0658 6.09928 11.2207C5.08946 10.3755 3.23181 9.88371 2.54389 10.6113Z"
          fill={colors.pink500}
        />
      </g>
      <mask id="path-7-inside-1_11830_10182" fill="white">
        <path d="M2.39961 8C2.39961 2.66667 7.79481 2.16053e-06 11.9996 8.39259e-07C16.2044 4.71664e-07 21.5996 2.66667 21.5996 8C21.5996 15.4667 16.2044 16 11.9996 16C7.79482 16 2.39961 15.4667 2.39961 8Z" />
      </mask>
      <path
        d="M3.46627 8C3.46627 5.7444 4.58968 4.04391 6.2411 2.8692C7.91805 1.67631 10.0972 1.06667 11.9996 1.06667L11.9996 -1.06666C9.69724 -1.06666 7.07637 -0.342974 5.00452 1.13081C2.90713 2.62276 1.33294 4.92227 1.33294 8L3.46627 8ZM11.9996 1.06667C13.902 1.06667 16.0812 1.67631 17.7581 2.86919C19.4095 4.04391 20.5329 5.7444 20.5329 8L22.6663 8C22.6663 4.92227 21.0921 2.62276 18.9947 1.13081C16.9228 -0.342975 14.302 -1.06667 11.9996 -1.06666L11.9996 1.06667ZM20.5329 8C20.5329 9.74071 20.2184 10.9958 19.7444 11.9082C19.2755 12.8107 18.6228 13.4325 17.8488 13.8729C16.2448 14.7857 14.1078 14.9333 11.9996 14.9333L11.9996 17.0667C14.0962 17.0667 16.7592 16.9476 18.904 15.7271C20.0044 15.1008 20.9633 14.1893 21.6374 12.8918C22.3064 11.6042 22.6663 9.99262 22.6663 8L20.5329 8ZM11.9996 14.9333C9.89139 14.9333 7.75439 14.7857 6.15038 13.8729C5.37645 13.4325 4.7237 12.8107 4.25485 11.9082C3.78077 10.9958 3.46627 9.74071 3.46627 8L1.33294 8C1.33294 9.99263 1.69284 11.6042 2.36177 12.8918C3.03592 14.1893 3.99477 15.1008 5.09524 15.7271C7.24003 16.9476 9.90303 17.0667 11.9996 17.0667L11.9996 14.9333Z"
        fill={colors.gray900}
        mask="url(#path-7-inside-1_11830_10182)"
      />
      <path
        d="M13.0648 11.6666C13.0648 11.998 12.7067 12.2666 12.2648 12.2666C11.823 12.2666 11.4648 11.998 11.4648 11.6666C11.4648 11.3352 11.823 11.2 12.2648 11.2C12.7067 11.2 13.0648 11.3352 13.0648 11.6666Z"
        fill={colors.gray900}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0813 10.1509C15.0489 10.126 15.0172 10.1008 14.9863 10.0753C13.9455 9.21705 13.6474 7.9024 14.3204 7.13896C14.9934 6.37552 16.3826 6.45239 17.4234 7.31065C17.9661 7.75827 18.4418 8.4395 18.6773 9.09722C18.6845 9.11137 18.6916 9.12551 18.6985 9.13966C19.2842 10.3326 18.9957 11.6439 18.0539 12.0684C17.1122 12.4929 15.8739 11.8699 15.2881 10.6769C15.2075 10.5127 15.1383 10.3355 15.0813 10.1509Z"
        fill={colors.gray900}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.448 10.1506C9.48039 10.1258 9.51209 10.1006 9.54305 10.0751C10.5838 9.2168 10.8819 7.90216 10.2089 7.13872C9.5359 6.37528 8.14666 6.45214 7.10594 7.3104C6.56316 7.75802 6.08748 8.43926 5.85203 9.09698C5.84482 9.11112 5.83775 9.12527 5.8308 9.13942C5.24505 10.3324 5.53364 11.6436 6.47539 12.0681C7.41713 12.4926 8.6554 11.8696 9.24115 10.6767C9.32178 10.5124 9.39102 10.3352 9.448 10.1506Z"
        fill={colors.gray900}
      />
    </svg>
  );
};
